import {Component, OnInit} from '@angular/core';
import {EvidencesService} from "../../../core/services/http/api/evidences.service";
import {ActivatedRoute, Router} from "@angular/router";
import {firstValueFrom} from "rxjs";
import {DocumentService} from "../../../core/services/document.service";
import {Workflow} from "../../../core/Models/Workflow";
import {TimeService} from "../../../core/services/time.service";

@Component({
  selector: 'app-single-audit',
  templateUrl: './single-audit.component.html',
  styleUrls: ['./single-audit.component.scss', '../../../../assets/audit/audit.scss']
})
export class SingleAuditComponent implements OnInit {

    public code:string;
    public loading: boolean = true;
    public document: any;

    public filters: any = {
        sign: false,
        event: false,
        event_data: {
            receiver: null,
            document: null,
            evidence: null,
        }
    }

    public Workflow: Workflow = Workflow;

    constructor(
        private evidencesService: EvidencesService,
        private router: Router,
        private route: ActivatedRoute,
        public documentService: DocumentService,
        public timeService: TimeService
    ) {

    }

    ngOnInit(): void {
        this.code = this.route.snapshot.params['code'];
        this.load()
    }


    async load() {
        if (!this.evidencesService.getJwt()) {
            const resp = await firstValueFrom(this.evidencesService.loginWithCode(this.code))
        }


        this.evidencesService.getEvidences().subscribe((data: any) => {
            this.document = data.data;
        }, err => {
            this.router.navigate(['audit'], { queryParams: { error: err.status } }).then()
        }).add(() => this.loading = false)
    }

    loadEvidenceSidebar(evidence, receiver) {
        this.filters.event_data.evidence = evidence;
        this.filters.event_data.receiver = receiver;
        this.filters.event_data.document = this.document;
        this.toggleFilterEvent()
    }

    toggleFilterEvent() {
        this.filters.sign = false;
        this.filters.event = !this.filters.event;
    }

    toggleFilterSign() {
        this.filters.event = false;
        this.filters.sign = !this.filters.sign;
    }

    closeFilters() {
        this.filters.event = false;
        this.filters.sign =  false;
        this.filters.event_data = {
            receiver: null,
            document: null,
            evidence: null,
        }
    }
}
